import React from 'react';
// import loader from '@assets/images/loader.gif';
import { withStyles } from '@material-ui/core/styles';

import CircularProgress from '@material-ui/core/CircularProgress';
const styles = (theme) => {
  return {
    root: {
      width: '100%',
      textAlign: 'center',
    },
  };
};
class Spinner extends React.Component {
  render() {
    const { style, children, classes } = this.props;

    return (
      <div className={classes.root} style={{ ...style }}>
        <div className={classes.loaderWrapper}>
          <CircularProgress />
          <br />
          <div className={classes.text}>{children}</div>
        </div>
      </div>
    );
  }
}

export default withStyles(styles)(Spinner);



// WEBPACK FOOTER //
// ./src/components/Spinner/Spinner.jsx